export default "__VITE_ASSET__65cc0f89__"